import { EmergencyAlertResponse } from '../models/emergency-alert-response.model';
import { AppData } from '@shared/models/appdata.model';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EmergencyAlertService {
  private http = inject(HttpClient);
  private appData = inject(AppData);

  apiUrl = this.appData.apiUrl + '/api/v1';

  messages(): Observable<EmergencyAlertResponse> {
    const url = `${this.apiUrl}/emergency/messages`;
    return this.http.get<EmergencyAlertResponse>(url);
  }
}
